/* eslint-disable */
export default {
  Ad: {
    ProgressText: 'BulkEdit_Ads_ProgressText',
    EmptySetTextError: 'BulkEdit_Ads_EmptySetTextError',
    TrackingTemplateProperty: 'AdTrackingTemplate',
    FinalUrlSuffixProperty: 'AdFinalUrlSuffix'
  },
  Keyword: {
    ProgressText: 'BulkEdit_Keywords_ProgressText',
    EmptySetTextError: 'BulkEdit_Keyword_EmptySetTextError',
    TrackingTemplateProperty: 'KeywordTrackingTemplate',
    FinalUrlSuffixProperty: 'KeywordFinalUrlSuffix'
  },
  AdGroup: {
    ProgressText: 'BulkEdit_AdGroups_ProgressText',
    EmptySetTextError: 'BulkEdit_AdGroup_EmptySetTextError',
    TrackingTemplateProperty: 'AdGroupTrackingUrlTemplate',
    FinalUrlSuffixProperty: 'AdGroupFinalUrlSuffix'
  },
  Campaign: {
    ProgressText: 'BulkEdit_Campaigns_ProgressText',
    EmptySetTextError: 'BulkEdit_Campaign_EmptySetTextError',
    TrackingTemplateProperty: 'CampaignTrackingUrlTemplate',
    FinalUrlSuffixProperty: 'CampaignFinalUrlSuffix'
  }
};

